import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { lowerFirst } from "lodash-es";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { SmsNotificationSettingsConfigService } from "./sms-notification-settings.config";
import { COMMUNUCATION_CHANNEL } from "./sms-notification-settings.const";
import { SmsNotificationRaw, SmsNotificationSettings } from "./sms-notification-settings.model";

@Injectable({
	providedIn: "root",
})
/**
 * @deprecated - [fabric-deprecated] - Use SmsNotificationSettingsService from app-account mfe instead
 */
export class SmsNotificationSettingsService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: SmsNotificationSettingsConfigService
	) {}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.GetSmsNotificationSettings) instead
	 */
	getAll(): Observable<SmsNotificationSettings> {
		return this.httpClient
			.get<SmsNotificationRaw[]>({
				url: this.config.getEndpoint(),
			})
			.pipe(map((response) => this.processRawSmsNotificationSettings(response)));
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.UpdateSmsNotificationSettings) instead
	 */
	update(payload: SmsNotificationSettings): Observable<object> {
		const smsNotificationSettings: SmsNotificationRaw[] = [
			{
				communicationChannel: COMMUNUCATION_CHANNEL,
				communicationName: "CustomerLoggedIn",
				isSubscribed: !!payload.customerLoggedIn,
			},
			{
				communicationChannel: COMMUNUCATION_CHANNEL,
				communicationName: "DepositSuccess",
				isSubscribed: !!payload.depositSuccess,
			},
			{
				communicationChannel: COMMUNUCATION_CHANNEL,
				communicationName: "WithdrawalSuccess",
				isSubscribed: !!payload.withdrawalSuccess,
			},
		];

		return this.httpClient.put<SmsNotificationRaw[]>({
			url: this.config.getEndpoint(),
			data: smsNotificationSettings,
		});
	}

	private processRawSmsNotificationSettings(response: SmsNotificationRaw[]): SmsNotificationSettings {
		const smsNotifications: Record<string, boolean> = {};

		for (const item of response) {
			const value = lowerFirst(item.communicationName);
			smsNotifications[value] = item.isSubscribed;
		}

		return smsNotifications;
	}
}
